import { useEffect, useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { MaskedNumberInput } from '../../forms/maskedNumberInput';
import { AlertInputs, ClearButtonProps } from './types';

export type BaseNumberInputProps = {
  alertInputName: AlertInputs;
  getValues: any;
  setValue: any;
  placeholder: string;
  inputLabelValue?: string;
  clearButton: (inputType: ClearButtonProps) => JSX.Element;
};

export const BaseNumberInput = ({
  alertInputName,
  getValues,
  setValue,
  placeholder,
  inputLabelValue,
  clearButton,
}: BaseNumberInputProps) => {
  const [localValue, setLocalValue] = useState(getValues(alertInputName));
  const [resetValues, setResetValues] = useState(getValues(alertInputName));
  const prevFormValueRef = useRef(getValues(alertInputName));

  // Sync localValue when form value changes externally (e.g. from reset())
  useEffect(() => {
    const formValue = getValues(alertInputName);
    const formValueStr = formValue != null ? String(formValue) : formValue;
    const localValueStr = localValue != null ? String(localValue) : localValue;
    const prevValueStr = prevFormValueRef.current != null ? String(prevFormValueRef.current) : prevFormValueRef.current;
    
    // Update if form value changed from previous or differs from local state
    if (formValueStr !== prevValueStr && formValueStr !== localValueStr) {
      prevFormValueRef.current = formValue;
      setLocalValue(formValue);
      if (formValue === '' || formValue === null || formValue === undefined) {
        setResetValues(new Date().getTime());
      }
    }
  });

  const handleValueChange = (val: number | string) => {
    setLocalValue(val);
    prevFormValueRef.current = `${val}`;
    setValue(alertInputName, `${val}`, {
      shouldDirty: true,
      shouldValidate: true,
    });
    if (val === '' || val === null || val === undefined) {
      setResetValues(new Date().getTime());
    }
  };

  return (
    <View style={styles.inputContainer}>
      <MaskedNumberInput
        key={`${resetValues}`}
        value={localValue}
        onChangeText={handleValueChange}
        onBlur={() => {}}
        placeholder={inputLabelValue || placeholder}
        decimalPlaces={0}
        hideClear={false}
        outlineStyle={{ borderWidth: 0 }}
        style={{
          flex: 1,
          backgroundColor: 'transparent',
          height: 52,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  inputContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'flex-start',
  },
});
